export const ucfirst = (s: string) => s.charAt(0).toUpperCase() + s.slice(1)
